__turbopack_context__.v({
  "body": "PTT-module-scss-module__d7ENFq__body",
  "container": "PTT-module-scss-module__d7ENFq__container",
  "imageContainer": "PTT-module-scss-module__d7ENFq__imageContainer",
  "imageWrapper": "PTT-module-scss-module__d7ENFq__imageWrapper",
  "label": "PTT-module-scss-module__d7ENFq__label",
  "link": "PTT-module-scss-module__d7ENFq__link",
  "logoContainer": "PTT-module-scss-module__d7ENFq__logoContainer",
  "textWhite": "PTT-module-scss-module__d7ENFq__textWhite",
  "title": "PTT-module-scss-module__d7ENFq__title",
  "wrapper": "PTT-module-scss-module__d7ENFq__wrapper",
});
